import { ButtonProps } from '@/components/Common/Button/Button.utils';
import { BUTTON_VARIANT } from '@/utils/enums';
import { BUTTON_VARIANT_TYPE } from '@/utils/types';
import { CircularProgress, Button as GeneralButton } from '@mui/material';
import styles from './Button.styles';

export default function Button({
  label,
  loading = false,
  disabled,
  btnVariant = BUTTON_VARIANT.PRIMARY,
  rounded = false,
  startIcon,
  sx,
  ...rest
}: ButtonProps) {
  const GET_STYLES = (variant: BUTTON_VARIANT_TYPE) => {
    switch (variant) {
      case BUTTON_VARIANT.PRIMARY:
        return {};
      case BUTTON_VARIANT.OUTLINED:
        return styles.outlined;
    }
  };
  return (
    <GeneralButton
      // className="notranslate"
      color="info"
      variant="contained"
      sx={{
        ...styles.button,
        ...GET_STYLES(btnVariant),
        ...(rounded ? { borderRadius: '8px' } : {}),
        ...sx,
      }}
      disabled={disabled || loading}
      type="submit"
      startIcon={startIcon}
      {...rest}
    >
      <span>
        {loading ? <CircularProgress color="inherit" size="22px" /> : label}
      </span>
    </GeneralButton>
  );
}
